import { useCallback, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

import ReleaseComponent from "../components/ReleaseComponent";
import { TabProvider } from "../../../../context";
import { tabArr } from "../constants";

const TAB_CONFIG = {
  firmware: {
    title: "Firmware Management",
    addButtonText: "Add New Firmware Version",
  },
  pilotApp: {
    title: "App Management",
    addButtonText: "Add New App Version",
  },
};

const ReleaseContainer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isAdd = pathname.includes("add");
  const tabValue = pathname.includes("firmware") ? "firmware" : "pilotApp";

  const { title, addButtonText } = TAB_CONFIG[tabValue];

  const addButtonClick = useCallback(() => {
    navigate(`${tabValue}/add`);
  }, [navigate, tabValue]);

  const setTab = useCallback(
    (value) => (e) => {
      e?.preventDefault?.();
      navigate(`./${value}`);
    },
    [navigate],
  );

  const tabContext = useMemo(
    () => ({ tabArr, tabValue, setTab }),
    [tabValue, setTab],
  );
  return (
    <TabProvider value={tabContext}>
      {!isAdd && (
        <ReleaseComponent
        //   title={title}
          addButtonText={addButtonText}
          addButtonClick={addButtonClick}
          isTabFilter
          isAction
        />
      )}
      <Outlet />
    </TabProvider>
  );
};

export default ReleaseContainer;
